import { Field, ErrorMessage } from "formik";

const PrimaryInput = ({ label, name, type = "text", placeholder = "", required = false }) => (
  <div>
    <label className="text-sm text-[var(--c-ink-2)] !mb-1.5 block">
      {label} {required && <span className="text-red-500">*</span>}
    </label>

    <Field
      type={type}
      name={name}
      placeholder={placeholder}
      className="w-full bg-[var(--c-surface2)] border border-[var(--c-border)] rounded-2xl !px-5 !py-3.5 text-[var(--c-ink)] placeholder:text-[var(--c-ink-3)] placeholder:opacity-75 focus:outline-none focus:border-violet-500 transition-colors"
    />

    <ErrorMessage name={name} component="p" className="text-red-400 text-xs !mt-2" />

    <style jsx global>{`
      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 1000px var(--c-surface2) inset !important;
        -webkit-text-fill-color: var(--c-ink) !important;
        caret-color: var(--c-ink) !important;
        transition: background-color 5000s ease-in-out 0s;
      }
    `}</style>
  </div>
);

export default PrimaryInput;
